import UserImage from '../../assets/user.png';
import api from '../Api';

export const fetchUsers = async () => {
  try {
    const response = await api.get('/admin/user/users');

    return response.data.users
      ? response.data.users.map(user => ({
          ...user,
          date_of_birth: new Date(user.createdAt).toLocaleDateString(),
          imageUrl: user.profilePictureUrl || UserImage,
        }))
      : [];
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
